import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState, useCallback } from "react";
import { validate as isValidEmail } from "email-validator";
import { Flex, Input, Button, Box, Text, useIsMounted } from "@catchoftheday/cg-components";
import { subscribeEmail } from "../../api";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SubscribeInput = function SubscribeInput(_ref) {
  var onSubmit = _ref.onSubmit;

  var _useState = useState(""),
      email = _useState[0],
      setEmail = _useState[1];

  var isMounted = useIsMounted();

  var _useState2 = useState(false),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var _useState3 = useState(false),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = useState(false),
      serverError = _useState4[0],
      setServerError = _useState4[1];

  var _useState5 = useState(false),
      touched = _useState5[0],
      setTouched = _useState5[1];

  var showError = touched && error;
  var validateEmail = useCallback(function (email) {
    setError(!isValidEmail(email));
  }, []);
  var handleChange = useCallback(function (e) {
    setEmail(e.currentTarget.value);
    validateEmail(e.currentTarget.value);
    setServerError(false);
  }, [setEmail, validateEmail]);
  var handleBlur = useCallback(function () {
    setTouched(true);
    setServerError(false);
  }, []);
  var handleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              if (!(error || !isValidEmail(email))) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setSubmitting(true);
              setServerError(false);
              _context.prev = 5;
              _context.next = 8;
              return subscribeEmail(email);

            case 8:
              _context.next = 10;
              return onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(email);

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              setServerError(true);

            case 15:
              /** Don't update state unless component is still mounted to avoid react warnings */
              if (isMounted()) {
                setSubmitting(false);
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [email, error, isMounted, onSubmit]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Flex, {
    as: "form",
    width: "100%",
    onSubmit: handleSubmit
  }, ___EmotionJSX(Input, {
    fontWeight: 100,
    fontSize: 14,
    disabled: submitting,
    type: "email",
    value: email,
    onChange: handleChange,
    onBlur: handleBlur,
    placeholder: "Your e-mail address",
    height: "54px",
    borderRadius: "4px",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    padding: "11px",
    error: showError
  }), ___EmotionJSX(Button, {
    onClick: function onClick() {
      validateEmail(email);
      handleBlur();
    },
    disabled: submitting || showError,
    type: "submit",
    variant: "secondary",
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    fontSize: 14,
    height: 54
  }, "SUBSCRIBE")), showError ? ___EmotionJSX(Box, null, ___EmotionJSX(Text, {
    color: "error"
  }, "Please enter a valid email address")) : null, serverError ? ___EmotionJSX(Box, null, ___EmotionJSX(Text, {
    color: "error"
  }, "Please try again")) : null);
};